import React, { Component } from 'react'
import VisualItems from './VisualItems.js'
import Button from '@material-ui/core/Button'
import { withRouter } from 'react-router-dom'
import { Grid, Paper, TextField, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import Fab from '@material-ui/core/Fab'
import { Add, AddCircle, Remove } from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'
import Seo from '../Seo/Seo'

const styles = theme => ({
  page: {
    marginTop: 70,
    padding: '24px 32px 40px',
  },

  header: {
    color: '#f5f1ff',
    fontWeight: 700,
    letterSpacing: 0.5,
    marginBottom: 6,
  },
  subhead: {
    color: 'rgba(245, 241, 255, 0.72)',
    marginBottom: 18,
  },
  emptyState: {
    color: 'rgba(245, 241, 255, 0.6)',
    marginTop: 12,
  },

  addActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  addFab: {
    boxShadow: '0 10px 18px rgba(0,0,0,0.3)',
    textTransform: 'none',
    fontWeight: 600,
    letterSpacing: 0.3,
  },

  // shared “glass card” style
  glassCard: {
    padding: '14px 16px',
    borderRadius: 18,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',
    boxShadow: '0 12px 26px rgba(0,0,0,0.28)',
    backdropFilter: 'blur(8px)',
  },

  // ✅ make Filter + Progress symmetrical
  sidebarCard: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },

  cardHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
    gap: 12,
  },

  // sticky column (apply to Grid item)
  stickyCol: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: 110,
      alignSelf: 'stretch',
      zIndex: 5,
    },
  },

  stickyInner: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('md')]: {
      transform: 'translateZ(0)',
    },
  },

  cardTitle: {
    color: '#f5f1ff',
    fontWeight: 800,
    letterSpacing: 0.6,
    fontSize: 18,
  },

  // Add panel row
  addPanelRow: {
    marginTop: 14,
  },

  // ✅ better alignment when open: centered + grid layout
  addPanel: {
    padding: '14px 16px',
    background: 'rgba(255, 255, 255, 0.06)',
    border: '1px solid rgba(255, 255, 255, 0.10)',
    borderRadius: 18,
    boxShadow: '0 10px 22px rgba(0,0,0,0.22)',
    backdropFilter: 'blur(8px)',

    width: '100%',
    maxWidth: 1180,
    margin: '0 auto',

    display: 'grid',
    gridTemplateColumns: '160px 1fr auto',
    gap: 14,
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },

  visualNumber: {
    width: '100%',
    '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: 'white',
    },
    marginLeft: 0,
  },
  visualUrl: {
    width: '100%',
    '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: 'white',
    },
    marginLeft: 0,
  },
  input: {
    color: 'white',
  },
  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: 'white',
    },
  },
  cssFocused: {},
  notchedOutline: { borderColor: 'rgba(255,255,255,0.35)' },

  addButton: {
    textTransform: 'none',
    fontWeight: 800,
    borderRadius: 999,
    paddingLeft: 18,
    paddingRight: 18,
    height: 44, // ✅ match filter/progress row height
    whiteSpace: 'nowrap',
    justifySelf: 'end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifySelf: 'stretch',
    },
  },

  // Progress
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
  },
  statRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 12px',
    height: 44,
    borderRadius: 14,
    background: 'rgba(12,12,16,0.45)',
    border: '1px solid rgba(255,255,255,0.08)',
  },
  statLabel: {
    fontWeight: 800,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    fontSize: 12,
    color: 'rgba(245,241,255,0.72)',
    lineHeight: 1,
  },
  statValue: {
    fontWeight: 900,
    fontSize: 18,
    color: '#f5f1ff',
    lineHeight: 1,
  },
  pillFound: { color: '#55d685' },
  pillMaybe: { color: '#f5d76e' },
  pillNot: { color: '#ff6b6b' },
  statTotal: {
    background: 'rgba(85, 214, 133, 0.12)',
    border: '1px solid rgba(85, 214, 133, 0.28)',
  },
  percentBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 12px',
    borderRadius: 999,
    fontWeight: 900,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    fontSize: 12,
    color: '#eafff3',
    background: 'rgba(85, 214, 133, 0.14)',
    border: '1px solid rgba(85, 214, 133, 0.32)',
    boxShadow: '0 10px 18px rgba(0,0,0,0.25)',
    whiteSpace: 'nowrap',
    lineHeight: 1,
  },

  // Filter
  filterButtons: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
  },
  filterBtn: {
    textTransform: 'none',
    fontWeight: 800,
    letterSpacing: 0.6,
    borderRadius: 14,
    padding: '10px 12px',
    height: 44,
    background: 'rgba(12,12,16,0.45)',
    border: '1px solid rgba(255,255,255,0.10)',
    color: 'rgba(245,241,255,0.92)',
    lineHeight: 1,
  },
  filterBtnActive: {
    background: 'rgba(138, 211, 255, 0.14)',
    border: '1px solid rgba(138, 211, 255, 0.30)',
    color: '#f5f1ff',
  },
})

class Visual extends Component {
  state = {
    toggleAdd: false,
    filter: 'ALL',
    addVisual: {
      visualNumber: '',
      url: '',
      contestId: 0,
    },
  }

  componentDidMount() {
    this.props.dispatch({ type: 'FETCH_VISUAL' })
    this.props.dispatch({ type: 'FETCH_TEAM_DETAILS' })
    this.props.dispatch({ type: 'FETCH_CURRENT_CONTEST', payload: this.props.user })
  }

  openAddForContest = (contestId) => {
    this.setState(prev => ({
      toggleAdd: true,
      addVisual: {
        ...prev.addVisual,
        contestId: contestId ?? prev.addVisual.contestId,
      },
    }))
  }

  closeAdd = () => this.setState({ toggleAdd: false })

  setFilter = (filter) => this.setState({ filter })

  // ✅ FIX: React/MUI-safe value extraction (prevents target=null crash)
  handleChangeFor = (propertyName) => (event) => {
    if (event && typeof event.persist === 'function') event.persist()

    const value =
      (event && event.currentTarget && typeof event.currentTarget.value !== 'undefined'
        ? event.currentTarget.value
        : undefined) ??
      (event && event.target && typeof event.target.value !== 'undefined'
        ? event.target.value
        : undefined) ??
      ''

    this.setState(prev => ({
      addVisual: {
        ...prev.addVisual,
        [propertyName]: value,
      },
    }))
  }

  handleVisualAdd = () => {
    const contestId = this.state.addVisual.contestId || this.props.team.current_contest
    this.props.dispatch({
      type: 'ADD_VISUAL',
      payload: {
        ...this.state.addVisual,
        contestId,
      },
    })
    this.setState({
      addVisual: {
        visualNumber: '',
        url: '',
        contestId,
      },
    })
  }

  getFilteredVisuals = (visuals, filter) => {
    if (!Array.isArray(visuals)) return []
    switch (filter) {
      case 'FOUND':
        return visuals.filter(v => v.match_level === 'Found')
      case 'MAYBE':
        return visuals.filter(v => v.match_level === 'Maybe Found')
      case 'NOT_FOUND':
        return visuals.filter(v => !v.match_level || v.match_level === 'Not Found')
      case 'ALL':
      default:
        return visuals
    }
  }

  render() {
    const { classes } = this.props
    const { toggleAdd, addVisual, filter } = this.state
    const canEdit = this.props.user?.clearance_id > 1

    const visuals = Array.isArray(this.props.visual) ? this.props.visual : []
    const filteredVisuals = this.getFilteredVisuals(visuals, filter)

    const foundCount = visuals.filter(v => v.match_level === 'Found').length
    const maybeCount = visuals.filter(v => v.match_level === 'Maybe Found').length
    const notFoundCount = visuals.filter(v => !v.match_level || v.match_level === 'Not Found').length
    const totalCount = visuals.length
    const percentFound = totalCount > 0 ? Math.round((foundCount / totalCount) * 100) : 0

    const filterLabel =
      filter === 'FOUND' ? 'Found'
        : filter === 'MAYBE' ? 'Maybe Found'
          : filter === 'NOT_FOUND' ? 'Not Found'
            : 'All'

    return (
      <div className={classes.page}>
        <Seo
          title="Visual Trivia Board | Trivia Weekend"
          description="Upload, filter, and solve visual trivia clues with the Trivia Weekend visual board."
          canonicalPath="/#/visual"
          ogType="website"
        />
        <Grid container spacing={4} alignItems="stretch">
          {/* Column 1: Title + Add/Close */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h3" component="h1" className={classes.header}>
              Visual Trivia
            </Typography>

            <Typography variant="h6" className={classes.subhead}>
              <i>{this.props.currentContest?.contest_name}</i>
            </Typography>

            {totalCount === 0 && (
              <Typography variant="subtitle1" className={classes.emptyState}>
                Let&apos;s upload this contest&apos;s visual trivia. Click add to get started.
              </Typography>
            )}

            {canEdit && (
              <div className={classes.addActions}>
                {!toggleAdd ? (
                  <Fab
                    color="primary"
                    aria-label="add"
                    className={classes.addFab}
                    style={{ backgroundColor: this.props.user.color }}
                    onClick={() => this.openAddForContest(this.props.team.current_contest)}
                    variant="extended"
                  >
                    <Add style={{ marginRight: 8 }} /> Add Visual
                  </Fab>
                ) : (
                  <Fab
                    color="secondary"
                    aria-label="remove"
                    className={classes.addFab}
                    onClick={this.closeAdd}
                    variant="extended"
                  >
                    <Remove style={{ marginRight: 8 }} /> Close
                  </Fab>
                )}
              </div>
            )}
          </Grid>

          {/* Column 2: Filter (sticky) */}
          <Grid item xs={12} sm={4} className={classes.stickyCol}>
            <div className={classes.stickyInner}>
              <Paper className={`${classes.glassCard} ${classes.sidebarCard}`}>
                <div className={classes.cardHeaderRow}>
                  <div className={classes.cardTitle}>Filter</div>
                  <div style={{ color: 'rgba(245,241,255,0.72)', fontWeight: 800 }}>
                    {filterLabel}
                  </div>
                </div>

                <div className={classes.filterButtons}>
                  <Button
                    className={`${classes.filterBtn} ${filter === 'ALL' ? classes.filterBtnActive : ''}`}
                    onClick={() => this.setFilter('ALL')}
                  >
                    All
                  </Button>

                  <Button
                    className={`${classes.filterBtn} ${filter === 'FOUND' ? classes.filterBtnActive : ''}`}
                    onClick={() => this.setFilter('FOUND')}
                  >
                    Found
                  </Button>

                  <Button
                    className={`${classes.filterBtn} ${filter === 'MAYBE' ? classes.filterBtnActive : ''}`}
                    onClick={() => this.setFilter('MAYBE')}
                  >
                    Maybe Found
                  </Button>

                  <Button
                    className={`${classes.filterBtn} ${filter === 'NOT_FOUND' ? classes.filterBtnActive : ''}`}
                    onClick={() => this.setFilter('NOT_FOUND')}
                  >
                    Not Found
                  </Button>
                </div>
              </Paper>
            </div>
          </Grid>

          {/* Column 3: Progress (sticky) */}
          <Grid item xs={12} sm={4} className={classes.stickyCol}>
            <div className={classes.stickyInner}>
              <Paper className={`${classes.glassCard} ${classes.sidebarCard}`}>
                <div className={classes.cardHeaderRow}>
                  <div className={classes.cardTitle}>Progress</div>
                  <div className={classes.percentBadge}>{percentFound}% FOUND</div>
                </div>

                <div className={classes.statsGrid}>
                  <div className={classes.statRow}>
                    <span className={`${classes.statLabel} ${classes.pillFound}`}>Found</span>
                    <span className={classes.statValue}>{foundCount}</span>
                  </div>

                  <div className={classes.statRow}>
                    <span className={`${classes.statLabel} ${classes.pillMaybe}`}>Maybe</span>
                    <span className={classes.statValue}>{maybeCount}</span>
                  </div>

                  <div className={classes.statRow}>
                    <span className={`${classes.statLabel} ${classes.pillNot}`}>Not Found</span>
                    <span className={classes.statValue}>{notFoundCount}</span>
                  </div>

                  <div className={`${classes.statRow} ${classes.statTotal}`}>
                    <span className={classes.statLabel}>Total</span>
                    <span className={classes.statValue}>{totalCount}</span>
                  </div>
                </div>
              </Paper>
            </div>
          </Grid>

          {/* Add panel full width */}
          {toggleAdd && canEdit && (
            <Grid item xs={12} className={classes.addPanelRow}>
              <Paper className={classes.addPanel}>
                <TextField
                  type="number"
                  id="visual-number"
                  label="Visual #"
                  className={classes.visualNumber}
                  value={addVisual.visualNumber}
                  onChange={this.handleChangeFor('visualNumber')}
                  margin="dense"
                  variant="outlined"
                  InputProps={{
                    className: classes.input,
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                  InputLabelProps={{ className: classes.input, shrink: true }}
                />

                <TextField
                  id="visual-url"
                  label="Image URL"
                  placeholder="https://..."
                  className={classes.visualUrl}
                  value={addVisual.url}
                  onChange={this.handleChangeFor('url')}
                  margin="dense"
                  variant="outlined"
                  InputProps={{
                    className: classes.input,
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                  InputLabelProps={{ className: classes.input, shrink: true }}
                />

                <Button
                  onClick={this.handleVisualAdd}
                  className={classes.addButton}
                  variant="contained"
                  style={{ backgroundColor: this.props.user.color, color: '#140f1f' }}
                  disabled={!String(addVisual.visualNumber).trim() || !String(addVisual.url).trim()}
                >
                  <AddCircle style={{ marginRight: 6 }} /> Add To Gallery
                </Button>
              </Paper>
            </Grid>
          )}
        </Grid>

        {/* Gallery */}
        <Grid container spacing={6} justifyContent="center" style={{ marginTop: 18 }}>
          {filteredVisuals.map((visual) => (
            <VisualItems key={visual.id} visual={visual} />
          ))}
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  team: state.team,
  visual: state.visual,
  currentContest: state.currentContest,
})

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Visual)))
